import React from 'react';
import PropTypes from 'prop-types';

class ModalFrame extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="ModalFrame" onClick={(e)=>{e.stopPropagation()}}>
                <style jsx>{`
                    .ModalFrame {
                        position:relative;
                        max-width:800px;
                        background:#fff;
                        min-height:90vh;
                        min-width:600px;
                        max-height:90vh;
                        border-radius:5px;
                        padding:20px;
                        overflow:hidden;
                    }
                    @media all and (max-width:600px){
                        .ModalFrame {
                            width:90vw;
                            min-width:90vw;
                            height:90vh;
                        }
                       
                    }
                `}</style>
                {this.props.children}
            </div>
        )
    }
}

ModalFrame.propTypes = {
    
}

export default ModalFrame;


// WEBPACK FOOTER //
// ./src/components/common/ModalFrame.js